import { GuardError } from '../../../errors/GuardError';
import { showAlert } from '../../../slices/alertSlice';
import { TThunkAction } from '../../../types/redux/thunk';
import { ETelemetryEvents } from '../../../types/telemetry';
import { setFirstMessageFailed } from '../actions';
import { EFirstMessageResponseStatus, IAssertDependencies, TFirstMessageResponse } from '../types';

export const assertUserCanNotChatWithHimselfStatus =
  (response: TFirstMessageResponse, { domain, telemetry }: IAssertDependencies): TThunkAction<void> =>
  (dispatch, _, { logger }) => {
    if (response.status === EFirstMessageResponseStatus.UserCanNotChatWithHimself) {
      telemetry.increment(ETelemetryEvents.ChatFirstMessageSendUserCanNotChatWithHimself);

      dispatch(setFirstMessageFailed());
      dispatch(showAlert({ message: 'Вы не можете написать сообщение самому себе' }));

      const error = new GuardError({
        message: 'Не удалось отправить первое сообщение: попытка написать самому себе',
        domain,
        details: { errorCode: response.status },
      });

      logger.error(error);
    }
  };
